var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 15.53125 19.765625 C 14.609375 19.765625 13.824219 20.355469 13.53125 21.175781 L 11.292969 21.175781 L 11.292969 19.765625 L 8.46875 19.765625 L 8.46875 21.175781 L 6.230469 21.175781 C 5.941406 20.355469 5.15625 19.765625 4.234375 19.765625 C 3.066406 19.765625 2.117188 20.714844 2.117188 21.882812 C 2.117188 23.050781 3.066406 24 4.234375 24 C 5.15625 24 5.941406 23.410156 6.230469 22.589844 L 13.53125 22.589844 C 13.824219 23.410156 14.609375 24 15.53125 24 C 16.695312 24 17.648438 23.050781 17.648438 21.882812 C 17.648438 20.714844 16.695312 19.765625 15.53125 19.765625 Z M 15.53125 19.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 17.648438 0 L 12.707031 0 C 10.367188 0 8.46875 1.894531 8.46875 4.234375 L 8.46875 7.058594 L 6.351562 7.058594 L 6.351562 8.46875 L 13.410156 8.46875 L 13.410156 7.058594 L 11.292969 7.058594 L 11.292969 4.234375 C 11.292969 3.457031 11.925781 2.824219 12.707031 2.824219 L 17.648438 2.824219 C 18.425781 2.824219 19.058594 3.457031 19.058594 4.234375 L 19.058594 14.117188 C 19.058594 14.898438 18.425781 15.53125 17.648438 15.53125 L 11.292969 15.53125 L 11.292969 11.292969 L 13.410156 11.292969 L 13.410156 9.882812 L 6.351562 9.882812 L 6.351562 11.292969 L 8.46875 11.292969 L 8.46875 15.53125 L 5.648438 15.53125 L 5.648438 18.351562 L 17.648438 18.351562 C 19.984375 18.351562 21.882812 16.457031 21.882812 14.117188 L 21.882812 4.234375 C 21.882812 1.894531 19.984375 0 17.648438 0 Z M 17.648438 0 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClamp);
export default __webpack_public_path__ + "static/media/clamp.3d0d5095.svg";
export { ForwardRef as ReactComponent };